import React from "react";
import { cn } from "@/lib/utils";

export const MAIN_PAGE_LIST_WIDTH_CLASS = "mx-auto min-w-0 w-full md:w-[min(100%,46.25rem)]";

export function MainPageListContainer(props: React.ComponentProps<"div">) {
    const { children, className, ...rest } = props;

    return (
        <div className={cn(MAIN_PAGE_LIST_WIDTH_CLASS, className)} {...rest}>
            {children}
        </div>
    );
}

/**
 * SV-138 (FRR `3a`): on a page that opts into the phone edge-to-edge shell but keeps a 16px column
 * gutter for its non-row blocks (`PageWithRailLayout`'s `px-4`: group, profile), the FEED list leaves
 * that gutter below `sm` so each row's divider runs screen edge to screen edge and the row's own
 * `FEED_ROW_GRID_CLASS` `px-4` is the only inset. `w-[calc(100%+2rem)]`, not `w-auto`: the stack is
 * `w-full`, and a negative margin does not widen a `width: 100%` box. Page-scoped by the call site,
 * never applied inside the stack, because the dashboard and discussion requests keep the default shell.
 */
export const MAIN_PAGE_LIST_EDGE_ON_PHONE_CLASS = "max-sm:-mx-4 max-sm:w-[calc(100%+2rem)]";

export function MainPageListStack(props: React.ComponentProps<"div">) {
    const { children, className, ...rest } = props;

    return (
        <div className={cn("flex min-w-0 w-full flex-col gap-2", className)} {...rest}>
            {children}
        </div>
    );
}
